import PubSub from 'pubsub-js';
import { useEffect } from 'react';

import { PUBSUB_APP_INITIALIZED } from '../utilities';

export default function useAppInitialized() {
  useEffect(() => {
    PubSub.publish(PUBSUB_APP_INITIALIZED, new Date());

    return () => {
      PubSub.unsubscribe(PUBSUB_APP_INITIALIZED);
    };
  }, []);
}
